export default "__VITE_ASSET__BQ_B$OwZ__"